<template>
  <AppDialog :is-open="isOpen"
             :ok-text="$t('common.delete')"
             :ok-loading="deleteUserPending"
             :ok-disabled="deleteUserPending"
             :cancel-disabled="deleteUserPending"
             @ok="prepareDeleteUser"
             @cancel="$emit('close')"
  >
    <template #title>{{ $t('subscriptions.SubscriptionSubscribersDeleteDialog.title') }}</template>
    <template #body>
      <v-row>
        <v-col>
          {{ $t('subscriptions.SubscriptionSubscribersDeleteDialog.text') }}
        </v-col>
      </v-row>
    </template>
  </AppDialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import AppDialog from '@/common/dialogs/AppDialog.vue'
import { toast } from '@/common/utils/toast'
import { DELETE_USER } from '@/store/modules/subscription/action_types'

export default {
  name: 'SubscriptionSubscribersDeleteDialog',
  components: { AppDialog },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    userToDelete: {
      required: true,
      validator: prop => typeof prop === 'object' || prop === null,
    },
  },
  computed: {
    ...mapState('subscription', ['deleteUserPending']),
  },
  methods: {
    ...mapActions('subscription', [DELETE_USER]),
    async prepareDeleteUser () {
      try {
        await this.DELETE_USER(this.userToDelete.id)
        toast.success(this.$t('subscriptions.SubscriptionSubscribersDeleteDialog.deleteUserSuccess'))
        this.$emit('userDeleteSuccess')
      } catch (error) {
        toast.error(this.$t('subscriptions.SubscriptionSubscribersDeleteDialog.deleteUserError'))
      }
    },
  },
}
</script>
